/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The styled components for WizardSummary
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.2.0
 */

import styled from 'styled-components';

import { fonts } from '../../../../../theme';

export const WizardSummaryInfoHtmlStyled = styled.div`
    ${fonts.textMainBold};
    > * {
        ${fonts.textMainBold};
    }
`;

export const WizardSummaryContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px;
    background-color: rgba(0, 185, 86, 0.14);
    border-radius: 8px;
`;

export const WizardSummaryParamContainerStyled = styled.div`
    margin-bottom: 12px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const WizardSummaryParamTitleStyled = styled.div`
    margin-bottom: 8px;
    ${fonts.textMainBold};
`;

export const WizardSummaryParamBodyStyled = styled.div`
`;

export const WizardSummaryParamValueStyled = styled.div`
    ${fonts.textMain};
`;
